import gsap from "gsap";

const infinityText = (container, elements) => {
    gsap.utils.toArray(container).forEach((line, i) => {
        const elems = line.querySelectorAll(elements);

        setInterval(()=>{
            line.querySelectorAll(elements).forEach(el  => {
                if(!el.getAttribute('style')) {
                    let tl = horizontalLoop(line.querySelectorAll(elements), {
                        repeat: -1, 
                        speed: 1.5,
                        reversed: i ? true : false,
                        paddingRight: parseFloat(gsap.getProperty(el, "margin-right", "px"))
                    });

                    elems.forEach(el  => {
                        el.addEventListener("mouseenter", () => gsap.to(tl, {timeScale: 0, overwrite: true}));
                        el.addEventListener("mouseleave", () => gsap.to(tl, {timeScale: i ? -1 : 1, overwrite: true}));
                    });
                }
            })
        }, 1000)
    });
};

export default infinityText;


function horizontalLoop(items, config) {
    let arr = gsap.utils.toArray(items);
    config = config || {};
    
    let tl = gsap.timeline({repeat: config.repeat, paused: config.paused, defaults: {ease: "none"}, onReverseComplete: () => tl.totalTime(tl.rawTime() + tl.duration() * 100)}),
        length = arr.length,
        startX = arr[0].offsetLeft,
        times = [],
        widths = [],
        xPercents = [],
        curIndex = 0,
        pixelsPerSecond = (config.speed || 1) * 100,
        snap = config.snap === false ? v => v : gsap.utils.snap(config.snap || 1), // some browsers shift by a pixel to accommodate flex layouts, so for example if width is 20% the first element's width might be 242px, and the next 243px, alternating back and forth. So we snap to 5 percentage points to make things look more natural
        totalWidth, curX, distanceToStart, distanceToLoop, item, i;
    
    gsap.set(arr, { // convert "x" to "xPercent" to make things responsive, and populate the widths/xPercents Arrays to make lookups faster.
        xPercent: (i, el) => {
            let w = widths[i] = parseFloat(gsap.getProperty(el, "width", "px"));
            xPercents[i] = snap(parseFloat(gsap.getProperty(el, "x", "px")) / w * 100 + gsap.getProperty(el, "xPercent"));
            return xPercents[i];
        }
    });

    gsap.set(arr, {
        x: 0
    });
    
    totalWidth = arr[length-1].offsetLeft + xPercents[length-1] / 100 * widths[length-1] - startX + arr[length-1].offsetWidth * gsap.getProperty(arr[length-1], "scaleX") + (parseFloat(config.paddingRight) || 0);
    
    for (i = 0; i < length; i++) {
        item = arr[i];
        curX = xPercents[i] / 100 * widths[i];
        distanceToStart = item.offsetLeft + curX - startX;
        distanceToLoop = distanceToStart + widths[i] * gsap.getProperty(item, "scaleX");
        tl.to(item, {
            xPercent: snap((curX - distanceToLoop) / widths[i] * 100), 
            duration: distanceToLoop / pixelsPerSecond
        }, 0)
        .fromTo(item, {
            xPercent: snap((curX - distanceToLoop + totalWidth) / widths[i] * 100)
        }, 
        {
            xPercent: xPercents[i], 
            duration: (curX - distanceToLoop + totalWidth - curX) / pixelsPerSecond, 
            immediateRender: false
        }, distanceToLoop / pixelsPerSecond)
        .add("label" + i, distanceToStart / pixelsPerSecond);
        
        times[i] = distanceToStart / pixelsPerSecond;
    }
    
    function toIndex(curIndex, vars, index) {
        vars = vars || {};
        
        (Math.abs(index - curIndex) > length / 2) && (index += index > curIndex ? -length : length);
        
        let newIndex = gsap.utils.wrap(0, length, index),
            time = times[newIndex];
        
        if ((time > tl.time()) !== (index > curIndex)) { 
            vars.modifiers = {time: gsap.utils.wrap(0, tl.duration())};
            time += tl.duration() * (index > curIndex ? 1 : -1);
        }

        curIndex = newIndex;
        vars.overwrite = true;
        return tl.tweenTo(time, vars);
    }

    tl.next = vars => toIndex(curIndex+1, vars);
    tl.previous = vars => toIndex(curIndex-1, vars);
    tl.current = () => curIndex;
    tl.toIndex = (index, vars) => toIndex(index, vars, index);
    tl.times = times;
    
    if (config.reversed) {
        tl.vars.onReverseComplete();
        tl.reverse();
    }

    return tl;
}